<div class="row">
    <div class="col-3">
        <div class="col-left p-3" *ngIf="!vendorContext">
            <h2>{{ customerName ?  ('popins.projects.customer_projects' | translate) + " " + customerName : ('popins.projects.my_projects' | translate) }}</h2>
            <p>{{ 'popins.projects.select_project' | translate }}</p>
        </div>
        <div class="col-left p-3" *ngIf="vendorContext">
            <span class="back" (click)="backToCustomerSearch()">&lt; {{ 'popins.projects.back_customer_search' | translate }}</span>
            <h2>{{ 'popins.projects.customer_projects' | translate }}<br/>{{ customerName }}</h2>
        </div>
    </div>

    <div class="col-9">
        <div class="header-actions">
            <button class="close" (click)="close()" title="{{ 'generic.close' | translate }}">
                <span class="icon-view-close" aria-hidden="true">
                    <svg>
                        <use xlink:href="assets/img/icons.svg#icon-view-close"></use>
                    </svg>
                </span>
                <span>{{ 'generic.close' | translate }}</span>
            </button>
        </div>

        <div class="p-4 project-list" *ngIf="!projectsDatas">
            <ng-hbm-bdi-loader></ng-hbm-bdi-loader>
        </div>        

        <div class="row p-4 project-list" *ngIf="projectsDatas">
            <div class="col-12">
                <div class="input-group project-search-bar mb-4">
                    <input type="text" class="form-control" [(ngModel)]="searchInputValue" [placeholder]="'popins.projects.search_projects' | translate" />
                    <div class="input-group-append">
                        <button class="btn btn-outline-secondary" (click)="filterDisplayedProjects()" type="button" id="button-addon2">
                            <svg>
                                <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="assets/img/icons.svg#icon-action-search"></use>
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
            <figure class="col-4 col-xl-3">
                <div class="card card-add-project"  (click)="newProject($event)">
                    <svg class="card-img-top">
                        <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="assets/img/icons.svg#icon-action-zoom"></use>
                    </svg>
                    <figcaption class="card-body">
                        <h3 class="card-title">{{ 'popins.projects.new_project' | translate }}</h3>
                    </figcaption>
                </div>
            </figure>
            <figure class="col-4 col-xl-3" *ngFor="let project of displayedProject">
                <div class="card" (click)="openProject(project.projectUUID, $event)">
                    <div class="embed-responsive embed-responsive-4by3">
                        <div class="embed-responsive-item" [style.background-image]="('url(\''+project.thumb+'\')') | safeStyle">
                            <div class="v-center">
                                <ng-hbm-bdi-btn *ngIf="!otherAccount" class="primary" (click)="openProject(project.projectUUID, $event)" [label]="'popins.projects.open_project' | translate"></ng-hbm-bdi-btn><br/>
                                <button (click)="duplicateProject(project.projectUUID, project.projectID, project.projectName, $event)" [title]="'generic.duplicate' | translate">
                                    <svg>
                                        <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="assets/img/icons.svg#icon-action-duplicate"></use>
                                    </svg>
                                </button>
                                <button *ngIf="!otherAccount && !project.is_locked" (click)="deleteProject(project.projectID, $event)" [title]="'generic.delete' | translate">
                                    <svg>
                                        <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="assets/img/icons.svg#icon-action-delete"></use>
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </div>
                    <figcaption class="card-body">
                        <h3 class="card-title">{{project.projectName}}</h3>
                        <p [innerHtml]="project.description | nl2br"></p>
                        <p class="project-date">{{project.dateUpdate | date:'d/MM/y H:mm' }}</p>
                    </figcaption>
                </div>
            </figure>
        </div>
    </div>
</div>